var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFrameHomepage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 758,
    height: 532,
    viewBox: "0 0 758 532",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42622 21.5001L3.35172 25.6268L3.2994 40.2027L8.47881 35.9732L8.42622 21.5001Z",
    fill: "#7AE7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4073 41.9298L3.3328 46.0736L3.28054 60.6321L8.45983 56.4198L8.4073 41.9298Z",
    fill: "#7AE7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38851 62.3768L3.31412 66.5035L3.26181 81.0794L8.44109 76.8499L8.38851 62.3768Z",
    fill: "#7AE7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3708 82.8065L3.29624 86.9503L3.24398 101.509L8.42333 97.2965L8.3708 82.8065Z",
    fill: "#7AE7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M731.586 1.65503L34.6176 1.50782L15.8934 18.1352L15.5879 101.629L4.95783 111.059L4.33949 280.053L11.2472 286.224L10.585 509.112L31.0143 527.36L736.408 527.509L749.934 515.512L750.546 306.367L746.136 302.429L746.674 155.372L750.183 152.26L750.67 18.9654L731.586 1.65503Z",
    fill: "#171717"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M751.934 213.104L756.973 217.62L756.916 233.564L751.794 228.954L751.934 213.104Z",
    fill: "#7AE7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M751.914 235.451L756.953 239.986L756.895 255.93L751.773 251.301L751.914 235.451Z",
    fill: "#7AE7FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M751.893 257.817L756.932 262.352L756.875 278.277L751.753 273.667L751.893 257.817Z",
    fill: "#7AE7FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M751.874 280.182L756.913 284.699L756.855 300.642L751.734 296.013L751.874 280.182Z",
    fill: "#7AE7FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1949 467.5L19.2332 472.016L19.1757 487.959L14.0542 483.331L14.1949 467.5Z",
    fill: "#7AE7FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1743 489.847L19.2125 494.382L19.1551 510.306L14.0335 505.696L14.1743 489.847Z",
    fill: "#7AE7FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M732.557 1.82283L32.2635 1.51297L13.5456 18.1306L13.3928 101.597L2.76637 111.021L2.48811 263.09L9.41608 269.26L9.12932 510.945L29.6184 529.192L738.349 529.506L751.87 517.516L752.101 306.439L747.678 302.501L747.947 155.492L751.454 152.382L751.698 19.1319L732.557 1.82283Z",
    stroke: "#7AE7FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameHomepage);
export default __webpack_public_path__ + "static/media/FrameHomepage.329f8a902e46c53ac95f97f0b9cc0f31.svg";
export { ForwardRef as ReactComponent };